import { useCallback, useEffect, useState } from "react";
import {
  fetchOdooLiveChatStatus,
  OdooLiveChatStatus
} from "services/odoo-live-chat/odoo-live-chat";

import { IUseOdooLiveChatStatus } from "./use-odoo-live-chat-status.types";

export const STATUS_POLL_MS = 60000;

// Online/offline from the cached status endpoint, polled while the launcher
// is shown and the tab is visible. Used before the widget bundle is loaded.
export const useOdooLiveChatStatus = (
  isEnabled: boolean
): IUseOdooLiveChatStatus => {
  const [serverStatus, setServerStatus] = useState<OdooLiveChatStatus | null>(
    null
  );

  useEffect(() => {
    if (!isEnabled) return;

    let isCancelled = false;
    const refresh = () => {
      if (document.visibilityState === "hidden") return;
      fetchOdooLiveChatStatus().then((status) => {
        if (!isCancelled) setServerStatus(status);
      });
    };
    refresh();
    const interval = setInterval(refresh, STATUS_POLL_MS);
    return () => {
      isCancelled = true;
      clearInterval(interval);
    };
  }, [isEnabled]);

  // Skips the CDN cache; for when the visitor explicitly retries.
  const refreshFresh = useCallback(async () => {
    const status = await fetchOdooLiveChatStatus(true);
    setServerStatus(status);
    return status;
  }, []);

  return {
    serverStatus,
    serverAvailable: serverStatus ? serverStatus.available : null,
    refreshFresh
  };
};
